import { Outlet } from "react-router-dom";

const Busqueda = () => {
  return (
    <div style={{ marginTop: "10px" }}>
      <Outlet />
    </div>
  );
};

export default Busqueda;
